import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Paragraph, Tag } from '@digdir/designsystemet-react';
import { AssessedRisk, riskRows, unassessedText } from '../reportView';
import { ReportSection } from './ReportSection';
import classes from '../WorkEnvironmentReport.module.css';

type Props = { risk: AssessedRisk; onOpenArea: (key: string) => void };

/** Highest risk first. Each area leads to its questions. */
export const RiskSection = ({ risk, onOpenArea }: Props): ReactElement => {
  const { t } = useTranslation();
  const unassessed = unassessedText(risk.unassessed, t);
  return (
    <ReportSection section="risk" intro={t('workEnvironmentReport.risk.intro')}>
      <ol className={classes.riskList}>
        {riskRows(risk.areas, t).map((row) => (
          <li key={row.key}>
            <span className={classes.riskName}>
              <a
                href={`#area-${row.key}`}
                className="ds-link"
                data-size="sm"
                onClick={(event) => {
                  event.preventDefault();
                  onOpenArea(row.key);
                }}
              >
                {row.name}
              </a>
              {row.adjusted && (
                <span className={`ds-paragraph ${classes.subtle}`} data-size="xs">
                  {t('workEnvironmentReport.risk.adjusted')}
                </span>
              )}
            </span>
            <span className={classes.scoreBar} data-color={row.color} aria-hidden="true">
              <span style={{ width: row.width }} />
            </span>
            <Tag data-size="sm" data-color={row.color} className={classes.riskTag}>
              {row.tag}
            </Tag>
          </li>
        ))}
      </ol>
      {unassessed && (
        <Paragraph data-size="sm" className={classes.subtle}>
          {unassessed}
        </Paragraph>
      )}
    </ReportSection>
  );
};
